import React, { useContext } from 'react';

import { AppContext } from '@prisjakt/ui-app-context';
import StoreLogo, { VARIANTS as LOGO_VARIANT } from '@prisjakt/ui-store-logo';

import * as S from './styles';

type OwnProps = {
  storeId?: number | null;
  storeName: string;
  featured?: boolean | null;
  hasLogo?: boolean | null;
  reviewCount?: number | null;
  logoUrl?: string | null;
  logoWidth?: number;
};

export const StoreInfoCard = ({
  featured,
  hasLogo,
  reviewCount,
  storeId,
  storeName,
  logoUrl,
  logoWidth = 88,
}: OwnProps) => {
  const { t } = useContext(AppContext);

  const highResolutionLogo = logoUrl
    ? { url: logoUrl, width: logoWidth }
    : null;

  const displayReviewCount =
    reviewCount && reviewCount > 500 ? '500+' : reviewCount || 0;

  return (
    <S.StoreCard>
      {featured && hasLogo && storeId && (
        <StoreLogo
          name={storeName}
          storeId={storeId}
          featured={featured}
          hasImage={hasLogo}
          variant={LOGO_VARIANT.REVIEWS}
          logoUrl={highResolutionLogo?.url}
          width={highResolutionLogo?.width}
          showHighResolutionLogo={Boolean(highResolutionLogo)}
        />
      )}
      <S.StoreInfo>
        <div>{storeName}</div>
        <div>
          {t('reviews', 'user.total-reviews', { n: displayReviewCount })}
        </div>
      </S.StoreInfo>
    </S.StoreCard>
  );
};

export default StoreInfoCard;
